import React from 'react';
import { Box, Stack, Typography, alpha } from '@mui/material';
import { getAccentColor, getBodyColor } from './shared';

const StudentResultsGridSection = ({ section, sectionKey, sectionIndex, resultCards, resultsGridColumns, resultsMetricMode, profileImageObjectPosition, renderHtmlTextBlock, renderPositionableElement }) => {
  const accent = getAccentColor(section) || '#4F46E5';
  const bodyColor = getBodyColor(section) || '#64748B';
  const columns = Math.max(1, Math.min(resultsGridColumns || 3, 4));

  return (
    <Box component="section" sx={{ py: { xs: 1, md: 1.6 }, width: '100%' }}>
      <Stack spacing={4}>
        {(section.title || section.body) && (
          <Stack spacing={1.5} alignItems={section.textAlign === 'center' ? 'center' : 'flex-start'} textAlign={section.textAlign || 'left'}>
            <Typography sx={{ display: 'inline-block', px: 1.5, py: 0.5, borderRadius: '6px', backgroundColor: alpha(accent, 0.1), color: accent, fontWeight: 700, fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Achievements</Typography>
            {section.title && <Typography component="h2" sx={{ color: '#0F172A', fontWeight: 800, fontSize: { xs: '2rem', md: '2.5rem' }, letterSpacing: '-0.02em', lineHeight: 1.1 }}>{section.title}</Typography>}
            {section.body && renderPositionableElement({ section, index: sectionIndex, elementKey: `${sectionKey}-intro`, children: renderHtmlTextBlock(section.body, { color: bodyColor, lineHeight: 1.7, fontSize: '1.1rem' }) })}
          </Stack>
        )}
        
        {resultCards.length ? (
          <Box sx={{ display: 'grid', gap: 3, gridTemplateColumns: { xs: '1fr', sm: `repeat(${Math.min(2, columns)}, 1fr)`, md: `repeat(${columns}, 1fr)` } }}>
            {resultCards.map((item, index) => (
              <Box key={`${sectionKey}-result-${index}`}>
                {renderPositionableElement({
                  section, index: sectionIndex, elementKey: `${sectionKey}-result-${index}`,
                  children: (
                    <Box sx={{ p: 3, borderRadius: '6px', backgroundColor: '#FFFFFF', border: `1px solid ${alpha('#0F172A', 0.06)}`, boxShadow: `0 4px 24px ${alpha('#0F172A', 0.03)}`, display: 'flex', flexDirection: 'column', height: '100%', '&:hover': { transform: 'translateY(-4px)' }, transition: 'transform 0.3s ease' }}>
                      <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>
                        {item.image && (
                          <Box sx={{ width: 64, height: 64, borderRadius: '6px', overflow: 'hidden', flexShrink: 0 }}>
                            <Box component="img" src={item.image} alt={item.name || ''} sx={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: profileImageObjectPosition || 'center' }} />
                          </Box>
                        )}
                        <Box>
                          <Typography sx={{ color: '#0F172A', fontWeight: 800, fontSize: '1.1rem' }}>{item.name || ''}</Typography>
                          {item.className && <Typography sx={{ color: '#64748B', fontSize: '0.85rem' }}>{item.className}</Typography>}
                        </Box>
                      </Stack>
                      
                      <Stack direction="row" spacing={1} flexWrap="wrap" mt="auto">
                        {(resultsMetricMode === 'percentage' || resultsMetricMode === 'both') && item.percentage && (
                          <Box sx={{ px: 2, py: 1, borderRadius: '6px', backgroundColor: alpha(accent, 0.1), color: accent, fontWeight: 800, fontSize: '0.9rem' }}>{item.percentage}</Box>
                        )}
                        {(resultsMetricMode === 'marks' || resultsMetricMode === 'both') && item.marks && (
                          <Box sx={{ px: 2, py: 1, borderRadius: '6px', backgroundColor: alpha('#F59E0B', 0.1), color: '#D97706', fontWeight: 800, fontSize: '0.9rem' }}>{item.marks}</Box>
                        )}
                      </Stack>
                    </Box>
                  ),
                })}
              </Box>
            ))}
          </Box>
        ) : (
          <Box sx={{ py: 6, textAlign: 'center', border: '2px dashed #CBD5E1', borderRadius: '32px', backgroundColor: '#F8FAFC' }}><Typography sx={{ color: '#64748B' }}>Add achievement cards in the editor.</Typography></Box>
        )}
      </Stack>
    </Box>
  );
};
export default StudentResultsGridSection;
